import { PauseOctagonOutlineIcon } from './PauseOctagonOutlineIcon';

/**
 * author: Austin Andrews
 * id 95AA0ED2-4221-4123-B3BF-9FACF3702CA4
 * name pause-octagon-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pause-octagon-outline.svg
 * tags
 */
export const StopPauseOutlineIcon = PauseOctagonOutlineIcon;
export default StopPauseOutlineIcon